<template>
	<div class="getCouponsBg">
		<div class="getCouponBg-container">
			<van-image class="getCouponBg-icon" fit="cover" src="../../../static/images/getCoupon2_bg.png" />
			<div class="getCouponBg-info">
				<div class="getCouponBg-left">
					<div class="coupons_price">
						<span class="coupons-mark">￥</span>
						<span class="coupons_num">{{couponInfo.coupon_par_value}}</span>
					</div>
					<div class="coupons_limit">满{{couponInfo.coupon_use_condition}}元可用</div>
				</div>
				<div class="getCouponBg-right">
					<div class="twoclamp getCoupon-title">{{couponInfo.coupon_name}}</div>
					<div class="getCoupon-date">{{couponInfo.coupon_starttime}}-{{couponInfo.coupon_endtime}}</div>
					<div class="getCoupon-surplus">券仅剩<span>{{parseFloat(left.toFixed(2))}}</span>%</div>
					<div class="surplus_progess">
						<div class="progess" :style="'width:'+ (left/100*58.66) +'vw'"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="getCoupon-btn-group">
			<van-button v-if="couponStatu == 1" class="getCoupon-btn getCoupon-btn-get" @click="getCoupon">领取</van-button>
			<van-button v-if="couponStatu == 2" class="getCoupon-btn getCoupon-btn-get">已领完</van-button>
			<van-button v-if="couponStatu == 3" class="getCoupon-btn getCoupon-btn-get">已领取</van-button>
			<van-button v-if="couponStatu == 4" class="getCoupon-btn getCoupon-btn-get">已结束</van-button>
		</div>
		<div class="getCoupons-limit">以下课程/直播支持使用该优惠券</div>
		<div class="getCoupons-limit-content">
			<div class="getCoupons-limit-item" v-for="(item, index) in goodsLimit" :key="index" @click="goToUse(item)">
				<van-image class="getCoupons-limit-img" fit="cover" :src="imgUrl+item.banner_image" />
				<div class="getCoupons-limit-right">
					<div class="getCoupons-limit-title">{{item.title}}</div>
					<div class="getCoupons-limit-statu">
						<div class="getCoupons-limit-price">￥{{item.price}}</div>
						<div v-if="item.good_type == 2" class="getCoupons-limit-sign">{{item.buy_num}}人已报名</div>
						<div v-if="item.good_type == 1" class="getCoupons-limit-sign">{{item.buy_num}}人已购买</div>
					</div>
				</div>
			</div>
		</div>
		<van-image class="toIndex" fit="cover" src="../../../static/images/toindex.png" @click="toIndex" />
	</div>
</template>

<script>
	export default{
		data(){
			return {
				imgUrl: 'http://sls.zhishen.net.cn', //图片拼接路径
				couponInfo: '',
				left: 0,
				couponTotal: 0,
				couponYlq: 0,
				goodsLimit: [],
				couponType: '', //判断是否是通用优惠券
				couponStatu: '' //优惠券状态
			}
		},
		created(){
			var that = this;
			//微信授权登录
			if (localStorage.getItem('userId') == null) {
				localStorage.setItem('beforeUrl', location.href.split('&')[0]);
				that.$router.push({path: '/author'})
			}
			that.$axios.get('http://sls.zhishen.net.cn/api/Coupon/couponDetail', {
				params: {
					user_id: localStorage.getItem('userId'),
					token: localStorage.getItem('token'),
					code: location.href.split('?')[1]
				}
			})
			.then(function(res) {
				that.couponInfo = res.data.coupon_info;
				that.goodsLimit = res.data.goods_list;
				that.couponType = res.data.coupon_info.coupon_type;
				that.couponTotal = res.data.coupon_info.coupon_circulation;
				that.couponYlq = res.data.coupon_info.coupon_drawnum;
				that.left = (that.couponTotal-that.couponYlq)/that.couponTotal*100;
				that.couponStatu = res.data.code;
			}).catch(function(error){
				console.log(error)
			})
		},
		methods:{
			//领取优惠券
			getCoupon(){
				var that = this
				let formdata = new FormData();
				formdata.append('user_id', localStorage.getItem('userId'));
				formdata.append('token', localStorage.getItem('token'));
				formdata.append('coupon_id', that.couponInfo.id);
				that.$axios.post('http://sls.zhishen.net.cn/api/Coupon/addUserCoupon', formdata)
				.then(function(res) {
					that.$toast({duration: 1000,message: '领取成功'});
					window.location.reload();
				}).catch(function(error){
					console.log(error)
				})
			},
			//回首页
			toIndex() {
				this.$router.push({
					path: '/'
				});
			},
			//点击适用课程/直播进入详情页
			goToUse(item){
				let that = this
				if(that.couponType == 0){
					window.location.href = that.login.pageUrl + '/';  //是通用优惠券则跳转到首页
				}
				if(that.couponType == 1){
					if(item.good_type == 1){
						window.location.href = that.login.pageUrl + '/coursedetail?courseId=' + item.id; //课程详情
					}
					if(item.good_type == 2){
						window.location.href = that.login.pageUrl + '/onlivedetail?liveId=' + item.id; //直播详情
					}
				}
			}
		}
	}
</script>

<style>
	@import url("../../assets/css/coupons.css");
</style>




// WEBPACK FOOTER //
// src/view/coupons/getCoupons.vue